import { render } from "./AccountRegister.vue?vue&type=template&id=29889cee"
import script from "./AccountRegister.vue?vue&type=script&lang=js"
export * from "./AccountRegister.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__